module.exports = __webpack_public_path__ + "img/material-title-xl.b7db4168.png";